module.exports = __webpack_public_path__ + "static/media/california_caviar_unagi.0f977c7c.webp";